import { Box, Button, Chip, Stack } from "@mui/material";
import CustomTable from "components/Table/CustomTable";
import { FC, useState } from "react";
import { Modal } from "components/Modal/Modal";
import { CoachesDetail } from "./CoachesDetail";
import { formatTime, getResponseSpeedColor, camelCaseToText } from "../utils";
import { ProcessedFeedback } from "../../../types/feedback";
import { UserWithPet } from "components/VetStore/CoachPetAvatar";

export type CoachesFeedbackTableProps = {
  processedFeedbacks: ProcessedFeedback[];
};

export const CoachesFeedbackTable: FC<CoachesFeedbackTableProps> = ({
  processedFeedbacks,
}: CoachesFeedbackTableProps) => {
  const [selectedCoach, setSelectedCoach] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpenModal = (coach: any) => {
    setSelectedCoach(coach);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedCoach(null);
  };

  return (
    <Box>
      <CustomTable
        entities={processedFeedbacks}
        handleActionClick={() => {}}
        fieldToFilter={(row, filterText) =>
          row.coach.name.toLowerCase().includes(filterText.toLowerCase())
        }
        columns={[
          {
            id: "name",
            label: "Name",
            value: (row: any) => (
              <Stack direction="row" spacing={2} alignItems={"center"}>
                <UserWithPet
                  pictureUrl={row?.coach?.picture_url}
                  name={row?.coach?.name}
                  equippedStoreItems={row?.coach?.equipped_store_items}
                  avatarSize={40}
                />
                <Box>{row?.coach?.name}</Box>
              </Stack>
            ),
          },
          {
            id: "avgTime",
            label: "AVG Time",
            value: (row: any) => formatTime(row.avgResponseTime),
          },
          {
            id: "totalFeedback",
            label: "Total Feedback",
            value: (row: any) => row.feedbacks.length,
          },
          {
            id: "responseSpeed",
            label: "Response Speed",
            value: (row: any) => {
              const category = camelCaseToText(row.category);
              return (
                <Chip
                  label={category}
                  sx={getResponseSpeedColor(category)}
                  size="small"
                />
              );
            },
          },
          {
            id: "details",
            value: (row: any) => (
              <Button
                color="primary"
                variant="outlined"
                size="small"
                sx={{ cursor: "pointer" }}
                onClick={() => handleOpenModal(row)}
              >
                Details
              </Button>
            ),
          },
        ]}
        isSelectable={false}
        idColumn={"coachId"}
        extraActionItems={[]}
        enableCardViewInSmallDevices
        enableMenuInSmallDevices={false}
      />

      <Modal
        open={isModalOpen}
        onClose={handleCloseModal}
        title={`Coach Details`}
        size="large"
      >
        <CoachesDetail processedFeedback={selectedCoach} />
      </Modal>
    </Box>
  );
};
